import React, {useEffect} from 'react';
import CircularProgress from "components/CircularProgress/index";
import Auxiliary from "util/Auxiliary";
import {useDispatch, useSelector} from "react-redux";
import {hideMessage} from "appRedux/actions/Common";
import { messageError, messageInfo } from '../../util/AlertMessage';

const InfoView = () => {

  const dispatch = useDispatch();

  const error = useSelector(({common}) => common.error);

  const loading = useSelector(({common}) => common.loading);

  const errorMessage = useSelector(({common}) => common.message);

  const displayMessage = errorMessage;

  useEffect(() => {
    if (error || errorMessage) {
      setTimeout(() => {
        dispatch(hideMessage());
      }, 3000);
    }
  }, [error, errorMessage, dispatch]);


  return (
    <Auxiliary>
      {loading && <div className="gx-loader-view gx-loader-position">
        <CircularProgress/>
      </div>}
      {error && messageError(<span id="message-id">{error}</span>)}
      {displayMessage && messageInfo(<span id="message-id">{displayMessage}</span>)}
    </Auxiliary>
  );
};

export default InfoView;
